<template>
    <section class="app-main">
        <div class="top-bar">
            <el-input placeholder="输入优惠返利名称" v-model="searchVal" @change="getData" style="width:240px;margin-right:30px" clearable>
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button  class="top-btn" type="success" plain @click="handleShow()">添加</el-button >
        </div>
        <el-card >
            <el-table :data="tableData"  height="580">
                <el-table-column prop="title" label="返利名称" align="center"></el-table-column>
                <el-table-column prop="rebate_scale" label="返利比例" align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.rebate_scale}}%</span>
                    </template>
                </el-table-column>
                <el-table-column prop="expire_type" label="有效期类型" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.expire_type == 0" style="color:green">固定天数</span>
                        <span v-else style="color:red">固定时间</span>
                    </template>
                </el-table-column>
                <el-table-column prop="expire_type" label="有效期" align="center" width="220">
                    <template slot-scope="scope">
                        <span v-if="scope.row.expire_type == 0">{{scope.row.expire_item}}天</span>
                        <span v-else>截止 {{scope.row.expire_item}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" align="center">
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.status"
                            :active-value="1"
                            :inactive-value="0"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            @change="changeStatus(scope.row)"
                            >
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="编辑" align="center" width="250">
                    <template slot-scope="scope">
                        <el-button type="success" plain size="mini"  @click="handleShow(scope.row)">修改</el-button>
                        <el-button type="danger"  plain size="mini"  @click="handleDel(scope.row)">删除</el-button> 
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="reloadData" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size"></el-pagination>
        </el-card>
        <!-- 添加 | 修改 弹出框 -->
        <el-dialog :visible.sync="dialog" :title="dialogTitle"  width="800px" align="center">
            <el-row class="line-item">
                <el-col :span="4" class="item-label">返利名称：</el-col>
                <el-col :span="20">
                    <el-input placeholder="返利名称" v-model="title" style="width: 80%"></el-input>
                </el-col>
            </el-row>
            <el-row class="line-item">
                <el-col :span="4" class="item-label">返利比例：</el-col>
                <el-col :span="20" class="item-label">
                    <el-input placeholder="例： 80% , 填80" v-model="rebate_scale" style="width: 40%"></el-input>
                </el-col>
            </el-row>
            <el-row class="line-item">
            <el-col :span="4" class="item-label">有效日期：</el-col>
            <el-col :span="20" class="item-label">
                <el-radio v-model="expire_type" :label="0" border>固定天数</el-radio>
                <el-radio v-model="expire_type" :label="1" border>固定时间</el-radio>
            </el-col>
            </el-row>
            <el-row class="line-item" v-if="expire_type == 1">
                <el-col :span="4" class="item-label">选择日期：</el-col>
                <el-col :span="20" class="item-label">
                     <el-date-picker v-model="expire_item" value-format="timestamp"  type="datetime" placeholder="选择时间"></el-date-picker>
                </el-col>
            </el-row>
            <el-row class="line-item" v-else>
                <el-col :span="4" class="item-label">有效天数：</el-col>
                <el-col :span="20" class="item-label">
                    <el-input placeholder='天数' v-model="expire_item"  style="width:183px;"></el-input>
                </el-col>
            </el-row>
            <el-row class="line-item">
                <el-col :span="4" class="item-label">状态：</el-col>
                <el-col :span="20" class="item-label">
                    <el-radio v-model="status" :label="1" border>启用</el-radio>
                    <el-radio v-model="status" :label="0" border>禁用</el-radio>
                </el-col>
            </el-row>
            <el-row type="flex" class="line-item" justify="center">
                <el-col :span="6" style="text-align:center"><el-button :disabled="disabled" type="info" plain @click="dialog = false" style="width:120px">取消</el-button></el-col>
                <el-col :span="6" style="text-align:center"><el-button :disabled="disabled" type="primary" plain @click="handleBtn" style="width:120px">确定</el-button></el-col>
            </el-row>
        </el-dialog>
    </section>
</template>
<script>
import { rebate_list, rebate_add, rebate_put, rebate_del } from '@/api/market.js'
import { parseTime } from '@/untils/index.js'
export default {
    data() {
        return {
            searchVal: '',
            tableData:[],
            table_load:false,
            total:0,
            page: 1,
            size: 0,
            dialog:false,    // 控制显示 添加修改弹窗
            dialogTitle:'',
            id:'',           //  有id 是修改  没有id是添加
            title:'',
            rebate_scale: '',
            expire_type: 0,
            expire_item: '',
            status: 1,
            disabled: false,
        }
    },
    methods: {
        getData() {
            let params = {
                page: this.page,
                is_page: 1
            }
            if(this.searchVal != '') {
                params.keywords = this.searchVal
            }
            rebate_list(params).then(res => {
                if(res) {
                    this.tableData = res.data.data
                    this.total = res.data.total
                    this.size  = res.data.per_page
                } else {
                    this.tableData = []
                    this.total = 0
                    this.size = 0
                }
            })
        },
        reloadData(page) {
            this.page = page;
            this.getData();
        },
        resetData() {
            this.id = ''
            this.title = ''
            this.status = 1
            this.expire_type = 0
            this.expire_item = ''
            this.rebate_scale = ''
        },
        // 显示 添加 || 修改 弹窗
        handleShow(row) {
            this.dialog = true
            if(row) {
                this.dialogTitle = '修改优惠返利'
                this.id = row.id
                this.title = row.title
                this.status = row.status
                this.rebate_scale = row.rebate_scale
                this.expire_type = row.expire_type
                this.expire_item = this.expire_type == 0 ? row.expire_item : new Date(row.expire_item)
            } else {
                this.dialogTitle = '添加优惠返利'
                this.resetData()
            }
        },
        // 弹窗里面 点击确定
        handleBtn() {
            // 通过 this.id 为空来判断 添加 || 修改
            if(this.title == '') {
                return this.$message({type:'warning', message: '请输入礼品名称'})
            }
            if(this.expire_item == '') {
                return this.$message({type:'warning', message: '请输入有效期'})
            }
            let params = {
                title: this.title,
                status: this.status,
                rebate_scale: this.rebate_scale,
                expire_type: this.expire_type,
                expire_item: this.expire_type == 0 ? this.expire_item : parseTime(this.expire_item/1000),
            }
            this.disabled = true
            if(this.id == ""){
                rebate_add(params).then(res => {
                    if(res) {
                        this.$message({message:res.msg,type:'success'})
                        this.getData()
                        this.resetData()
                        this.dialog   = false
                    }
                }).finally( () => {
                    this.disabled = false
                })
            } else {
                rebate_put(this.id, params).then(res => {
                    if(res) {
                        this.$message({message:res.msg,type:'success'})
                        this.getData()
                        this.resetData()
                        this.dialog   = false
                    }
                }).finally( () => {
                    this.disabled = false
                })
            }
        },
        // 修改状态
        changeStatus(row) {
            rebate_put(row.id, {status:row.status}).then(res => {
                if(res) {
                    this.$message({type:"success",message:res.msg})
                }
            })
        },
        // 删除 活动
        handleDel(row) {
            this.$confirm(`此操作将删除礼品："${row.title}"，是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                rebate_del(row.id).then(res => {
                    this.$message({type:"success",message:res.msg})
                    this.getData();
                })
            }).catch(() => {});
        },
    },
    created(){
        this.getData()
    },
    activated() {
        this.getData()
    },
}
</script>

<style lang="less" scoped>
section {
    .top-btn {
        width: 100px;
    }
    .item-label {
        height: 40px;
        line-height: 40px;
        text-align: left;
    }
    .line-item {
        margin-top: 25px;
        &:nth-child(1){
            margin-top: 0;
        }
    }
    /deep/ .el-dialog__body {
        text-align: left
    }
}
</style>
